module.exports = __webpack_public_path__ + "img/loader.4cbe4c33.jpg";